import { styled } from "@mui/material/styles";
import { Box, IconButton, Typography } from "@mui/material";
import { colors } from "../../../theme/theme";

export const backdropProps = {
  timeout: 500,
  sx: {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    backdropFilter: "blur(4px)",
  },
};

export const StyledModalBox = styled(Box, {
  shouldForwardProp: (prop) => !["modalHeight", "modalWidth"].includes(prop),
})(({ theme, modalHeight = "90%", modalWidth }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.35)",
  borderRadius: "30px",
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: modalWidth || "auto",
  minWidth: modalWidth ? "unset" : "400px",
  height: modalHeight,
  [theme.breakpoints.down(700)]: {
    width: "100%",
    minWidth: "unset",
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    minWidth: "unset",
  },
}));

export const StyledHeaderBox = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${colors.lightBorder}`,
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontWeight: 500,
  fontSize: "28px",
  color: colors.primary,
  textAlign: "center",
  letterSpacing: "0.2px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

export const StyledContentBox = styled(Box)({
  flex: 1,
  overflowY: "auto",
  "::-webkit-scrollbar": {
    width: "8px",
  },
  "::-webkit-scrollbar-thumb": {
    backgroundColor: "#492A18",
    borderRadius: "4px",
  },
  "::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#65412C",
  },
  "::-webkit-scrollbar-track": {
    backgroundColor: "#EAE6DA",
  },
});

export const StyledButtonsBox = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${colors.lightBorder}`,
  paddingTop: 0,
  paddingBottom: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  "& > .MuiButton-root": {
    width: "auto",
    minWidth: "min-content",
    maxWidth: "100%",
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
}));

export const StyledCloseButton = styled(IconButton)({
  position: "fixed",
  top: 16,
  right: 16,
  zIndex: 9999999,
  color: "#492A18",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  height: "50px",
  width: "50px",
  "&:hover": {
    backgroundColor: "rgba(234, 230, 218, 1)",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "30px",
  },
});
